@if (headerWrapperData$ | async; as headerWrapperData) {
  @if (headerWrapperData.showHeader) {
    @if (headerWrapperData.user === null) {
      <app-landing-header />
    }
    @if (headerWrapperData.user !== null && !headerWrapperData.isUserCompanySc) {
      <app-user-header [user]="headerWrapperData.user" />
    }
  }
}
